import {
  createBrowserRouter,
} from "react-router-dom";
import ErrorPage from "../../error-page";
import AdminLayout from "../../layout/AdminLayout";
import NotFound from "./NotFound";

const routerReparateur = createBrowserRouter([
  {
    path: "/",
    element: <AdminLayout SidebarLinkSections={[]} />,
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        element: <h1>Welcome!</h1>,
      },
      {
        path: "contacts/:contactId",
        element: <h1>Contact!</h1>,
      },
    ],
  },

  {
    path: '*',
    element: <NotFound />,
  }

]);

export default routerReparateur;